import { hideVisually } from 'polished';
import styled from 'styled-components';

export const HiddenInput = styled.input`
  ${hideVisually};
`;

export const LabelContainer = styled.label<{ $width?: number | string }>`
  width: ${({ $width }) => $width};
`;
